import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { BannerModel } from '../models/banner.model';

@Injectable({
  providedIn: 'root'
})
export class MarketingService {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);

  getBanner(): Observable<BannerModel> {
    return this._http.get<BannerModel>(this.__URL_API__ + 'api/MarketingInfo/clientBanner').pipe(
      take(1),
      catchError((error) => {
        console.error('Error fetching marketing banner', error);
        return of(null);
      })
    );
  }
}
